module.exports = __webpack_public_path__ + "assets/00c5109c0e8e2ef606dcd921e15e8a9a.svg";